import { render } from "./QuickContactBar.vue?vue&type=template&id=1ba0ce6f"
import script from "./QuickContactBar.vue?vue&type=script&lang=js"
export * from "./QuickContactBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__